import {BackendErrorType} from "../model/Backend";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {
    faTriangleExclamation
} from '@fortawesome/free-solid-svg-icons';

export default function ErrorMessage({data, messages}) {
    if (!data || data.isSuccess())
        return null;
    messages = {
        [BackendErrorType.ConnectionError]: "Please check your internet connection.",
        [BackendErrorType.GeneralError]: "An error occurred, please refresh the website.",
        ...messages
    }
    const styles = "text-red-400";
    return <>
        {data.errors.map((error, index) =>
            <div key={index} className="flex justify-center space-x-2 mb-2">
                <FontAwesomeIcon icon={faTriangleExclamation} className={`my-auto ${styles}`}/>
                <p className={styles}>
                    {error in messages ? messages[error] : error}
                </p>
            </div>
        )}
        <div className="mb-1"></div>
    </>;
}